import { VIDEOS } from './actionTypes';

const initialState = {
  videos: null,
  loading: {
    videos: false,
  },
  error: {
    videos: null,
  },
};

const VideosReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case VIDEOS.VIDEOS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, videos: true },
        error: { ...state.error, videos: null },
      };
    case VIDEOS.VIDEOS_SUCCESS:
      return {
        ...state,
        videos: payload,
        loading: { ...state.loading, videos: false },
      };
    case VIDEOS.VIDEOS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, videos: false },
        error: { ...state.error, videos: error },
      };

    default:
      return state;
  }
};

export default VideosReducer;
